import { createFileRoute } from "@tanstack/react-router"
import { EditProfilePage } from "@/pages"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/profile/edit"
)({
  component: EditProfilePage,
})
